import { css } from 'styled-components';

/**
 * The shape of a control in a list/media toolbar: one height, one corner radius, for the List/Grid
 * switcher, Select, Tags, the search field, Advanced Search and the download triggers alike.
 *
 * 34px is the app's toolbar-control height — the ui-kit Button is knocked down to it by both list
 * scaffolds (LeftCluster forces it on its own button children) and the search field/button are built to
 * it. The media controls were instead sized by vertical padding (7px 14px), which lands at ~31px, and
 * SegmentedToggle's track added its own padding on top of a 34px segment for a 42px outer box. That was
 * survivable while each toolbar was self-consistent, but the scaffolds only stretch the buttons they can
 * reach: anything behind a wrapper div (Tags) and everything in the toolbar's right-hand cluster (the
 * download pair) kept its own size, so a single row mixed 31, 34 and 42px and nothing lined up.
 *
 * Lives in the ui-kit because SegmentedToggle needs the constant too, and the ui-kit can't import from
 * modules/. Anything wearing this is the same height and radius on every toolbar, new design or legacy.
 */
export const TOOLBAR_CONTROL_HEIGHT = '34px';
export const TOOLBAR_CONTROL_RADIUS = '8px';

export const toolbarControl = css`
  height: ${TOOLBAR_CONTROL_HEIGHT};
  box-sizing: border-box;
  padding: 0 14px;
  border-radius: ${TOOLBAR_CONTROL_RADIUS};
`;

export default toolbarControl;
